import Spinner from "components/General-UI/Spinner";
import CopyButton from "components/Home/ui/CopyButton";
import { INVITE_LINK_START_V01 } from "constants/constants";
import React, { useEffect, useState } from "react";
import {
  createInviteCode,
  deleteInviteCode,
  getInviteCode,
} from "slices/peopleSlice";

const EfficeLink = ({ effId }) => {
  const [code, setCode] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getInviteCode(effId)
      .then((code) => {
        setCode(code);
        setLoaded(true);
      })
      .catch(() => {
        setLoaded(true);
      });
  }, [effId]);

  return (
    <div className="link-share-row">
      {/* <div className="link-share-title">Effice Invite Link:</div> */}
      {!loaded ? (
        <Spinner bgDark={false} spinnerLight={false} immediateShow={false} />
      ) : (
        <>
          {code ? (
            <>
              <div className="link-font">
                {`${INVITE_LINK_START_V01}${code}`}
              </div>
              <div className="effice-link-buttons">
                <CopyButton textToCopy={`${INVITE_LINK_START_V01}${code}`} />
                <span
                  className="invite-delete"
                  onClick={async () => {
                    setLoaded(false);
                    await deleteInviteCode(effId).then(() => {
                      setCode(null);
                    });
                    setLoaded(true);
                  }}
                >
                  disable
                </span>
              </div>
            </>
          ) : (
            <>
              <div
                className="confirm-button growth-button get-effice-link"
                onClick={async () => {
                  setLoaded(false);
                  await createInviteCode(effId).then((newCode) => {
                    setCode(newCode);
                  });
                  setLoaded(true);
                }}
              >
                Make Effice Invite Link
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default EfficeLink;
